import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';

import styled from 'styled-components';

import { getCommunityShopNotes } from 'apis/ShopNotesAPI';
import ItemViewHistory from 'components/CommunityInfo/careTypes/common/ItemViewHistory';
import { ITEM_VIEW_HISTORY_CLASS } from 'components/CommunityInfo/careTypes/constants';
import { useCommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';

import ShopNotesContent from './ShopNotesContent';
import { useSnapshotContext } from '../../../../common/Snapshot/SnapshotContext';
import { FIELD_CATEGORY, FIELD_LABELS, SHOP_NOTES_FIELD } from '../../../ShopData/constants';
import Header from '../../common/header/Header';

const Container = styled.div`
  box-sizing: border-box;
  position: relative;

  &:hover ${`.${ITEM_VIEW_HISTORY_CLASS}`} {
    opacity: 1;
    visibility: visible;
  }
`;

const ShopNotes = () => {
  const { setHistory } = useCommunityInfoContext();
  const { snapshot } = useSnapshotContext();
  const { competitorId } = useParams();
  const { communityId } = useParams();
  const id = Number(competitorId || communityId);

  const { data: shopNotes } = useQuery({
    queryKey: ['community', 'shop', 'notes', id, snapshot],
    queryFn: () => getCommunityShopNotes(id, { snapshot: snapshot?.uuid }),
    enabled: Boolean(id) && Boolean(snapshot),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const handleViewHistory = () => {
    const category = FIELD_CATEGORY.SHOP_NOTES;
    const field = SHOP_NOTES_FIELD;

    const history = {
      category: FIELD_CATEGORY.SHOP_NOTES,
      field: SHOP_NOTES_FIELD,
      label: FIELD_LABELS[category][field],
    };
    setHistory(history);
  };

  const hasData = shopNotes?.length > 0;

  if (!hasData) {
    return null;
  }

  return (
    <Container>
      <Header title="Shop Notes" addOn={<ItemViewHistory onClick={handleViewHistory} />} />
      <ShopNotesContent data={shopNotes} />
    </Container>
  );
};

export default ShopNotes;
